import React from 'react';
import MagicForm from '../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';
import { QuestionnaireModule } from '../../Enums/QuestionnaireModule.enum';
import { useAppContext } from '../../../../Services/AppContext';

interface QuestionnairePlanningDisposableFormProps {
	onSubmit: (values: any) => void;
	defaultData?: any;
	addDoctor: boolean;
	module?: QuestionnaireModule;
}

export default function QuestionnairePlanningDisposableForm(
	props: QuestionnairePlanningDisposableFormProps,
) {
	const { defaultData, onSubmit, addDoctor, module } = props;
	const { isMou } = useAppContext();

	const handleSubmit = async (values: any) => {
		onSubmit(values);
	};

	const formSchemePrepend: ItemScheme[] = [];
	if (addDoctor) {
		formSchemePrepend.push({
			type: MagicField.DOCTOR_SELECT,
			key: 'doctor',
			title: 'component.questionnaires.fromDoctor',
			settings: {
				required: true,
				useRoot: isMou,
			},
		});
	}

	let formScheme: ItemScheme[] = [
		{
			type: MagicField.PATIENT_SELECT,
			key: 'patient',
			title: 'component.questionnaires.forPatient',
			settings: {
				required: true,
			},
		},
		{
			type: MagicField.WORKPLACE_SELECT,
			key: 'workplace',
			title: 'base.shared.workplace',
			settings: {
				required: true,
			},
		},
		{
			type: MagicField.QUESTIONNAIRE_SELECT,
			key: 'questionnaire',
			title: 'base.shared.questionnaire',
			settings: {
				required: true,
				enablePicker: true,
				module: module,
			},
		},
		{
			type: MagicField.HSTACK,
			children: [
				{
					type: MagicField.DATEPICKER,
					key: 'dateFrom',
					title: 'component.questionnaires.sentDate',
					settings: {
						required: true,
						rules: [
							{
								rule: 'min',
								value: 'today',
							},
						],
					},
				},
				{
					type: MagicField.TIMEPICKER,
					key: 'time',
					title: 'component.questionnaires.sentTime',
					settings: {
						hideRequired: true,
						placeholder: 'base.shared.now',
						minuteStep: 5,
					},
				},
			],
		},
	];

	formScheme = [...formSchemePrepend, ...formScheme];

	return (
		<MagicForm
			registerForChanges
			formScheme={formScheme}
			onSubmit={handleSubmit}
			defaultValues={defaultData}
			submitText={'component.treatment.questionnaire.send'}
		/>
	);
}
